export default {
      id: "download-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#download-usage",
      toString: function () {
        return this.url;
      }
    }